import { setupEditPanelGroupDialog } from '../reducers/edit_panel_group_dialog';
import { showDialog } from '../reducers/app';
export function newPanelGroup(panel_id) {
    return (dispatch) => {
        dispatch(setupEditPanelGroupDialog({
            id: null,
            panel_id,
            title: '',
            ord: 0
        }));
        dispatch(showDialog('group-edit'));
    };
}
